module.exports = __webpack_public_path__ + "img/marker_one_red1.3809cad7.png";